import { API_URL } from "config";
import Http from "util/https";
import Notify from "config/notify";
import { RegisterBillParam } from "../types";

/**
 * 六行伝票を登録するAPI
 * @param params 六行伝票のパラメータ
 */
export default async function registerBillApi(params: RegisterBillParam) {
  console.log("registerBillApi params:", params);

  const http = Http.default.alterAuth({ useToken: true });
  const url = `${API_URL}/order/product/regist`;
  const res = await http.post<string[]>(url, params);
  return res.data.slice(1).filter(msg => msg.includes('-')); // 編集した場合に注文作成番号を使用する。["注文登録に成功しました。","116157-20250711184444-001","116157-20250711184445-001"]
  // await new Promise<void>((resolve) => {setTimeout(resolve, 1500)});

  // const res = {status: 200};
  // if (res.status === 200) {
  //   Notify.setNotification({
  //     show: true,
  //     title: "更新が完了しました",
  //     confirmLabel: "OK",
  //     actionsPosition: "end",
  //   });
  // }
}
